<script setup lang="ts">
import { computed } from "vue";
import Headline from "../components/Headline.vue";
import Section from "../components/Section.vue";
import { List, ListItem } from "../components/List";
import RedrawNotes from "../../RedrawNotes.vue";
import SmartRedrawNotes from "../../SmartRedrawNotes.vue";
import { useDtfStore } from "../../store";
import type { Standard } from "../../types";

defineProps<{
  onPrintPerfectClick: () => void;
  artwork: Standard.Artwork;
  index: number;
}>();

const store = useDtfStore();
const isStandardDTFProduct = computed(() => store.isStandardDTFProduct);
const showSmartRedrawNote = computed(() => (store.experiments as any).ab_smart_redraw_notes === 1);
</script>

<template>
  <Headline>
    <template #title>For Pros who know.</template>
    <template #subtitle>
      You don't need our help. We print exactly as you send it, without any cutting edge,
      industry-leading print enhancements.
    </template>
  </Headline>

  <Section class="print-as-is__section">
    <List>
      <ListItem kind="warning">
        No
        <a href="/jiffy-transfers-FAQs#transfer-quality-guarantee" target="_blank">
          PrintPerfect Guarantee
        </a>
      </ListItem>
      <ListItem kind="warning">No safety net</ListItem>
      <ListItem kind="warning">Quality depends on uploaded design</ListItem>
    </List>
  </Section>

  <div v-if="isStandardDTFProduct" class="print-as-is__notes">
    <SmartRedrawNotes v-if="showSmartRedrawNote" :artwork="artwork" :index="index" />
    <RedrawNotes v-else :index="index" :enhancement-note="artwork.enhancementNote" />
  </div>
</template>

<style scoped lang="scss">
.print-as-is {
  &__section {
    gap: 20px;
  }

  &__notes {
    margin-top: 10px;
  }
}
</style>
